import { useMutation } from 'react-query';
import { AuthAPI } from '../../api/auth';
import { API } from '../../services/api';

export const useLogoutMutation = () => {
  return useMutation<{ message: string }, { error: { message: string } }>(() =>
    API.deleter(AuthAPI.logout),
  );
};
